var BlockView = require('views/block/base-block-view');

let ContainerView = BlockView.extend({
  initialize: function() {
    this.model.set('cid', this.model.cid);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.renderNestedBlocks(`${this.model.get('cid')}-blocks`, this.model.get('blocks'));
  },
  play: function() {
    this.readyToGo();
  }  
});

export default ContainerView;